import { render, staticRenderFns } from "./AdminClassGradeBook.vue?vue&type=template&id=7d4e269e&scoped=true"
import script from "./AdminClassGradeBook.vue?vue&type=script&lang=js"
export * from "./AdminClassGradeBook.vue?vue&type=script&lang=js"
import style0 from "./AdminClassGradeBook.vue?vue&type=style&index=0&id=7d4e269e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4e269e",
  null
  
)

export default component.exports